

import React from 'react';
import { EventsWidget, QuotationsWidget, TasksWidget } from '../widgets';
import type { DashboardData } from '../../useDashboard';

interface ListsSectionProps {
  data: DashboardData;
}

export function ListsSection({ data }: ListsSectionProps) {
  const showTasks = data.sections.tasks;

  return (
    <div className="grid grid-cols-1 xl:grid-cols-3 gap-4 sm:gap-6">
      <div className={`${showTasks ? 'xl:col-span-2' : 'xl:col-span-3'} space-y-4 sm:space-y-6`}>
        <EventsWidget
          today={data.today}
          todayEvents={data.today_events}
          upcomingEvents={data.upcoming_events}
          upcomingCount={data.counts.upcoming_events}
        />
        {data.sections.quotations && <QuotationsWidget quotations={data.recent_quotations} />}
      </div>

      {showTasks && (
        <div className="space-y-4 sm:space-y-6">
          <TasksWidget
            today={data.today}
            tasks={data.open_tasks}
            openCount={data.counts.open_tasks ?? 0}
            overdueCount={data.counts.overdue_tasks ?? 0}
          />
        </div>
      )}
    </div>
  );
}
